import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    Link,
    StyleSheet
} from '@react-pdf/renderer';

const FormsPDFComponent = (props) => {
    const { FormData } = props;

    const styles = StyleSheet.create({
        page: {
            backgroundColor: 'white',
            paddingTop: '1.27cm',
            paddingBottom: '1.09cm',
            paddingLeft: '0.69cm',
            paddingRight: '0.69cm',
        },
        container: {
            flexDirection: 'column',
            alignItems: 'stretch',
        },
        questionContainer: {
            marginBottom: '16px',
        },
        answerText: {
            marginBottom: '8px',
        },
        linkText: {
            color: 'blue',
            textDecoration: 'underline',
        },
    });

    const renderSwitch = FormData.map((val, index) => (
        val.TEXT && val.TEXT.trim() !== "" ? (
            <View key={index} style={styles.questionContainer}>
                <Text className="mb-2">{val.QUESTIONS} :</Text>
                {val.TYPE.toLowerCase() === "attachment" && val.TEXT && val.TEXT.trim() !== "" ? (
                    <Link src={val.TEXT.trim()} target="_blank" style={styles.linkText} className="mb-4">{val.TEXT}</Link>
                ) : (
                        <Text style={styles.answerText} className="mb-4">{val.TEXT}</Text>
                    )}
            </View>
        ) : null
    ));


    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.container}>
                    {renderSwitch}
                </View>
            </Page>
        </Document>
    );
};

export default FormsPDFComponent;
